module.exports = __webpack_public_path__ + "static/media/artist_yhe-x_w.2cf36a29.png";